export default function CircleColor({ color = '#FD7E14' }) {
    return (
        <div style={{ position: 'relative', marginLeft: 'auto' }}>
            <div style={{ width: 11, height: 11, backgroundColor: color, borderRadius: '50%', zIndex: 1, position: 'relative' }} />
            <div style={{ position: 'absolute', top: '50%', left: '50%', width: '14px', height: '14px', backgroundColor: color, borderRadius: '50%', zIndex: 0, transform: 'translate(-50%, -50%)', opacity: 0.7 }} />
        </div>
    );
}